export enum AssociationLabel {
  DIRECT = 'DIRECT',
  PASSIVE = 'PASSIVE',
  PROSPECT = 'PROSPECT',
  REFERRALS = 'REFERRALS',
  WAITING_FOR_APPLICATION = 'WAITING FOR APPLICATION',
}
